import { render } from "./CharacterReincarnation.vue?vue&type=template&id=0f40cbda&scoped=true"
import script from "./CharacterReincarnation.vue?vue&type=script&lang=js"
export * from "./CharacterReincarnation.vue?vue&type=script&lang=js"

import "./CharacterReincarnation.vue?vue&type=style&index=0&id=0f40cbda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f40cbda"]])

export default __exports__